

import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_SegmentedToggle";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_SegmentedToggle__root","divider":"wds_1_209_0_SegmentedToggle__divider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-segmented-toggle-border-radius-medium":"--wds-segmented-toggle-border-radius-medium","wds-segmented-toggle-border-radius-small":"--wds-segmented-toggle-border-radius-small","wds-segmented-toggle-border-width-default":"--wds-segmented-toggle-border-width-default","wds-segmented-toggle-fill-default":"--wds-segmented-toggle-fill-default","wds-segmented-toggle-background-fill":"--wds-segmented-toggle-background-fill","wds-color-text-disabled":"--wds-color-text-disabled","wds-color-border-standard-secondary":"--wds-color-border-standard-secondary","wds-color-border-standard-secondary-disabled":"--wds-color-border-standard-secondary-disabled","wds-color-fill-standard-tertiary":"--wds-color-fill-standard-tertiary"}; 




